if (!customElements.get('jc-scroll-to-top')) {
  class JCScrollToTop extends HTMLElement {
    constructor() {
      super();

      // Create button element
      const button = this.querySelector(".btn");

      if (!button) return;

      // Scroll event listener to toggle button visibility
      window.addEventListener("scroll", () => {
        console.log('window.scrollY', window.scrollY);
        if (window.scrollY > 200) {
          this.classList.add('show');
          this.classList.remove('hide');
        } else {
          this.classList.add('hide');
          this.classList.remove('show');
        }
      });

      // Click event listener to scroll to the top
      button.addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }
  }

// Define the custom element
  customElements.define("jc-scroll-to-top", JCScrollToTop);
}
